export default __webpack_public_path__ + "static/media/CS-RaceWeek-Brasil(330x330).71db70ee.webp";